/* eslint-disable @typescript-eslint/naming-convention */
export type MediaType = 'Z' | '5' | 'M' | '02' | 'P' | 'S' | 'E' | 'V' | 'B' | MechatronicPlanType;
export type MechatronicPlanType = 'MA' | 'MC' | 'MD' | 'MI' | 'MS';

export const MediaTypes = {
    OperationManual: 'Z' as MediaType,
    RetrofitManual: '5' as MediaType,
    AssemblingInstruction: 'M' as MediaType,
    RepairingInstruction: '02' as MediaType,
    Brochure: 'P' as MediaType,
    LubricationPlan: 'S' as MediaType,
    SparepartsList: 'E' as MediaType,
    Video: 'V' as MediaType,
    Image: 'B' as MediaType,
    MechatronicPlanTypes: ['MA', 'MC', 'MD', 'MI', 'MS'] as Readonly<MechatronicPlanType[]>,
} as const;
